import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31a6fcca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6" }

import { FormRules } from '@/utils';
import { User } from '@/models/user';
import { computed, ref } from 'vue';
import {
  getEmptyUserForm,
  getFormByInstance,
  getUserTypeOptions,
  UserForm,
} from '../models/user-form';
import QForm from 'quasar/src/components/form/QForm.js';import useQuasar from 'quasar/src/composables/use-quasar.js';;

interface Props {
  users: User[];
  user?: User | null;
}

interface Emits {
  (e: 'cancel'): void;
  (e: 'save', formData: UserForm): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    users: null,
    user: null
  },
  emits: ["cancel", "save"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'cancel'): void;
  (e: 'save', formData: UserForm): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  users: User[];
  user?: User | null;
}




const quasar = useQuasar();

const formData = ref<UserForm>(getEmptyUserForm());

const form = ref<InstanceType<typeof QForm> | null>(null);

const supervisorOptions = computed(() => {
  const supervisors = props.users.filter(
    (user) => user.type === User.TYPE_ADMIN || user.type === User.TYPE_SUPERVISOR
  );

  return supervisors.map((user) => ({ label: user.name, value: user.id }));
});

const isEdit = computed(() => props.user !== undefined && props.user !== null);

const resetForm = () => {
  formData.value = getEmptyUserForm();
};

const save = () => {
  form.value?.validate().then((success) => {
    if (success) {
      emit('save', formData.value);
    } else {
      quasar.notify({
        type: 'warning',
        message: 'Por favor confira os campos obrigatórios.',
      });
    }
  });
};

const cancel = () => {
  emit('cancel');
  resetForm();
};

const setUser = (user: User | null) => {
  if (user !== null) {
    formData.value = getFormByInstance(user);
  } else {
    resetForm();
  }
};

const blockFieldSupervisor = (typeUser: string): boolean => {
  if(typeUser === User.TYPE_ADMIN || typeUser === User.TYPE_SUPERVISOR || typeUser === User.TYPE_DEVELOPER){
    return true;
  }
  else{
    return false;
  }
};

expose({ resetForm, setUser });

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!

  return (_openBlock(), _createBlock(_unref(QForm), {
    ref_key: "form",
    ref: form,
    class: "ni-form q-gutter-md",
    onSubmit: save,
    autofocus: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(isEdit) ? 'Editar Usuário' : 'Cadastrar Usuário'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "q-pt-none q-gutter-sm" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: formData.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
            label: "Nome",
            "lazy-rules": "",
            rules: [_unref(FormRules).required]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: formData.value.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
            label: "Email",
            "lazy-rules": "",
            rules: [_unref(FormRules).required]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: formData.value.document,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.document) = $event)),
            label: "Documento",
            "lazy-rules": "",
            rules: [_unref(FormRules).required]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: formData.value.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.phone) = $event)),
            label: "Telefone",
            "lazy-rules": "",
            rules: [_unref(FormRules).required]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: formData.value.password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.password) = $event)),
            label: "Senha",
            "lazy-rules": "",
            rules: !_unref(isEdit) ? [_unref(FormRules).required, _unref(FormRules).password] : []
          }, null, 8, ["modelValue", "rules"]),
          (!_unref(isEdit) || formData.value.password.length > 0)
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 0,
                outlined: "",
                modelValue: formData.value.passwordConfirm,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.passwordConfirm) = $event)),
                label: "Confirmação da senha",
                "lazy-rules": "",
                rules: [_unref(FormRules).confirm(formData.value.password, 'Senha')]
              }, null, 8, ["modelValue", "rules"]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_select, {
            outlined: "",
            modelValue: formData.value.type,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.type) = $event)),
            label: "Tipo",
            "lazy-rules": "",
            rules: [_unref(FormRules).required],
            options: _unref(getUserTypeOptions)(),
            "emit-value": "",
            "map-options": ""
          }, null, 8, ["modelValue", "rules", "options"]),
          _createVNode(_component_q_select, {
            outlined: "",
            clearable: "",
            modelValue: formData.value.supervisorId,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.supervisorId) = $event)),
            label: "Supervisor",
            options: _unref(supervisorOptions),
            "map-options": "",
            "emit-value": "",
            disable: blockFieldSupervisor(formData.value.type)
          }, null, 8, ["modelValue", "options", "disable"]),
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: formData.value.region,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.region) = $event)),
            label: "Região",
            "lazy-rules": "",
            rules: [_unref(FormRules).required]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: formData.value.regional,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.regional) = $event)),
            label: "Regional",
            "lazy-rules": "",
            rules: [_unref(FormRules).required]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_actions, { align: "right" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            flat: "",
            label: "Cancelar",
            onClick: cancel
          }),
          _createVNode(_component_q_btn, {
            type: "submit",
            color: "primary",
            label: "Salvar"
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})